import type { ScreenItem } from 'shared/src/types';
import { HomeScreen } from './screens/Home/Home.screen';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type HomeStackParamList = {};

export const HomeScreens: ScreenItem[] = [
  {
    name: 'Home',
    component: HomeScreen,
    path: '/home',
  },
];
export const HomeTabScreens: ScreenItem[] = [
  {
    name: 'Home',
    component: HomeScreen,
    path: '/home',
  },
];
